export default "__VITE_ASSET__afe1abc3__"